import { render } from "./EmptyCartIcon.vue?vue&type=template&id=3d9b4506"
import script from "./EmptyCartIcon.vue?vue&type=script&lang=js"
export * from "./EmptyCartIcon.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__